import {
  type AsyncStateObject, type Action, type GoalListResponse
} from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, GOAL_ACTIONS } from '../../../utils/constants'

/*
  This reducer is used to get the My Goals by Passing the Assignee in body Parameter
  @Kalana Elapatha
*/
const INITIAL_STATE: AsyncStateObject<GoalListResponse> = {
  data: { count: 0, data: [] },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const getGoalByUserReducer = (
  state = INITIAL_STATE,
  action: Action<GoalListResponse>
): AsyncStateObject<GoalListResponse> => {
  switch (action.type) {
    case GOAL_ACTIONS.GET_GOAL_BY_USER + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case GOAL_ACTIONS.GET_GOAL_BY_USER + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case GOAL_ACTIONS.GET_GOAL_BY_USER + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: { count: 0, data: [] },
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case GOAL_ACTIONS.GET_GOAL_BY_USER + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default getGoalByUserReducer
